






















































































































































import { getStudentSelectList, studentExperience } from "@/api/classManagement";
import { studentAdd } from "@/api/rollCallRecord";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() lessonData!: any;
  @Prop() studentType!: number;
  searchInfo: any = {};
  selected: any[] = [];
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  dialogVisible: boolean = false;
  openDialog() {
    this.dialogVisible = true;
    this.selected = [];
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  getList(params: {
    page: number;
    page_size: number;
    original_class_id?: number;
    lesson_id?: number;
    student_name?: string;
    key_word?: string;
    status?: any;
  }) {
    if (this.studentType === 1) {
      //临时
      if (this.searchInfo.key_word) {
        params.key_word = this.searchInfo.key_word;
      }
      params.original_class_id = this.lessonData.class_id;
      params.lesson_id = this.lessonData.lesson_id;
      getStudentSelectList(params).then((res: any) => {
        if (res.error_code === 0) {
          if (res.data.list.length > 0) {
            res.data.list.map((a: any) => {
              a.chooseItemCid = a.course_list[0].course_id;
              a.chooseItem = a.course_list[0];
            });
          }
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.page = params.page;
        }
      });
    } else {
      //体验
      if (this.searchInfo.key_word) {
        params.key_word = this.searchInfo.key_word;
      }
      params.lesson_id = this.lessonData.lesson_id;
      studentExperience(params).then((res: any) => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.page = params.page;
      });
    }
  }
  chooseCourse(e: any, item: any) {
    item.course_list.map((a: any) => {
      if (a.course_id == e) {
        item.chooseItem = a;
      }
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleSelectionChange(arr: any) {
    this.selected = arr;
  }
  hideDialog() {
    this.dialogVisible = false;
  }
  handleSubmit() {
    const option: any = {
      roll_call_id: this.lessonData.roll_call_id,
    };
    if (this.selected.length === 0) {
      this.$message({
        type: "error",
        message: "请先选择学员",
      });
      return false;
    }
    const arr: any[] = [];
    this.selected.map((item: any) => {
      let course_id = 0;
      if (this.studentType === 1) {
        course_id = item.chooseItemCid ? item.chooseItemCid : 0;
      } else {
        course_id = this.lessonData.course_id;
      }
      arr.push({
        student_id: item.student_id,
        course_id: course_id,
        student_type: this.studentType,
        student_status: 1,
        consume_number:
          this.studentType == 5 ? "0" : this.lessonData.consume_number,
      });
    });
    option.student_list = arr;
    studentAdd(option).then((res: any) => {
      if (res.error_code == 0) {
        this.$message({
          type: "success",
          message: "添加成功!",
        });
        this.hideDialog();
        this.$emit("change");
      } else {
        this.$message({
          type: "error",
          message: "添加失败!" + res.message,
        });
      }
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
